import { TimePickerConstants } from './TimePickerConstants';
import {userConstants} from "../../../views/auth/_redux/authConstants";
import moment from "moment";

const makeInitialState = () => ({
  currentDate: {
    from: moment().hour(0).minute(0).second(0).millisecond(0),
    to: moment().hour(23).minute(59).second(59).millisecond(999),
    raw: { from: "now/d", to: "now/d" }
  },
});

export function timePicker(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case TimePickerConstants.TIMEPICKER_SET_DATE:
      return {
        ...state,
        currentDate: action.currentDate
      };
    
    default:
      return state
  }
}
